import {Typography} from "@mui/material";
import {Link} from "@reach/router";
import * as React from "react";
import {useResources} from "../../stores/ResourceProvider";
import globalStyles from "../../styles/globalStyles";

const TaxDisclaimer = () => {
  const {termsOfUse} = useResources()

  return (
    <>
      <Typography variant="body2" gutterBottom sx={{mt:1}}>
        <strong>Tax Disclaimer</strong>&nbsp;
        The United States Federal and State Income Tax Systems are complex. The tax estimates provided within the Retirement Budget Calculator are limited in scope and intended for illustrative purposes only. These estimates are not guaranteed and should not be relied upon for tax preparation or financial decision-making. Actual tax liability may vary significantly.
      </Typography>
      <Typography variant="body2" gutterBottom>
        For state income taxes, we use an <b>average effective rate based on your state</b>, which <b>you may adjust to better reflect your personal situation</b>. This is not a precise calculation of your actual state tax obligation.
      </Typography>
      <Typography variant="body2" gutterBottom>
        The accuracy of your results depends in part on the data you enter. We recommend consulting with a qualified tax adviser to review and validate any tax-related assumptions or projections. Do not make financial or tax decisions based on these estimates without professional guidance. Tax laws and rates are subject to change, and updates to this calculator may not reflect the most current legislation. It is your responsibility to validate all inputs and outputs for accuracy.
      </Typography>
      <Typography variant="body2" gutterBottom>
        Please review our&nbsp;
        <Link to="." onClick={() => termsOfUse.show()} style={globalStyles.link}>Terms of Use</Link>.
      </Typography>
    </>
  )
}

export default TaxDisclaimer